import axios from "@/api/axios";

const getHistory = page => {
  return axios
    .get(`/v1/history/`, { params: { p: page } })
    .then(resp => resp.data);
};

export default getHistory;
